import { Button, Col, Form, Input, Option, Row, Select } from "@tv2no/ui-react";
import React, { useEffect, useState } from "react";
import { getTaxYearList } from "../../api/services/taxYear";
import { getMunicipalityListByYear } from "../../api/services/geo-lists"; 

export const FilterForm = ({ selectedYear, onFilter, busy }) => {
    const [year, setYear] = useState(selectedYear);
    const [yearList, setYearList] = useState(null);
    const [municipalityList, setMunicipalityList] = useState([]);
    const [selectedMunicipality, setSelectedMunicipality] = useState(null);
    const [sortOption, setSortOption] = useState("income");
    const [sortOrder, setSortOrder] = useState("Desc");
    const [birthYearGreaterThan, setBirthYearGreaterThan] = useState(null);
    const [birthYearEqualTo, setBirthYearEqualTo] = useState(null);
    const [birthYearLessThan, setBirthYearLessThan] = useState(null);

    
    useEffect(() => {
        getTaxYearList().then((result) => {
            setYearList(result);
        });

        getMunicipalityListByYear({ page: 0, size: 1000, year: year }).then((result) => {
            const municipalities = result.content || result; 
            const filteredMunicipalities = municipalities.filter(municipality => 
                municipality.published && municipality.taxYears.includes(Number(year))
            );
            filteredMunicipalities.sort((a, b) => a.name.localeCompare(b.name));
            setMunicipalityList(filteredMunicipalities);
        });
    }, [year]);

    const clearFields = () => {
        setYear(selectedYear);
        setSelectedMunicipality(null);
        setSortOption(null);
        setSortOrder("Desc");
        setBirthYearGreaterThan(null);
        setBirthYearEqualTo(null);
        setBirthYearLessThan(null);
    };

    
    const handleFilter = () => {
        const birthYearFilters = [];
        if (birthYearGreaterThan) {
            birthYearFilters.push({ birthYear: birthYearGreaterThan, birthYearFilterType: "greaterThan" });
        }
        if (birthYearEqualTo) {
            birthYearFilters.push({ birthYear: birthYearEqualTo, birthYearFilterType: "equalTo" });
        }
        if (birthYearLessThan) {
            birthYearFilters.push({ birthYear: birthYearLessThan, birthYearFilterType: "lessThan" });
        }

        const requestBody = {
            sortBy: sortOption,
            sortOrder: sortOrder,
            size: 50,
            offset: 0
        };
        if (birthYearFilters.length > 0) {
            requestBody.birthYearFilters = birthYearFilters;
        }

        if (selectedMunicipality) {
            const municipality = municipalityList.find(m => m.id === selectedMunicipality);
            requestBody.municipality = { id: selectedMunicipality, municipality: municipality.name };
        }

        onFilter(requestBody);
    };

    return (
        <Form>
            <Row spacing="small">
                <Col xs={24} md={8} lg={4}>
                <Select value={year} placeholder="Skatteår" onChange={setYear}>
                        {yearList &&
                            yearList.map((entry) => (
                                <Option key={entry.year} value={entry.year}>
                                    {entry.year}
                                </Option>
                            ))}
                    </Select>
                </Col>
            </Row>
            <Row spacing="small">
                <Col xs={24} md={8} lg={4}>
                    <Select
                        placeholder="Municipality"
                        value={selectedMunicipality}
                        onChange={setSelectedMunicipality}
                    >
                        {municipalityList &&
                            municipalityList.map((municipality) => (
                                <Option key={municipality.id} value={municipality.id}>
                                    {municipality.name}, {municipality.id}
                                </Option>
                            ))}
                    </Select>
                </Col>
            </Row>
            <Row spacing="small">
                <Col xs={24} md={8} lg={8}>
                    <Input
                        placeholder="Optional, Birth Year Greater Than"
                        value={birthYearGreaterThan}
                        onChange={setBirthYearGreaterThan}
                    />
                </Col>
                <Col xs={24} md={8} lg={8}>
                    <Input
                        placeholder="Optional, Birth Year Equal To"
                        value={birthYearEqualTo}
                        onChange={setBirthYearEqualTo}
                    />
                </Col>
                <Col xs={24} md={8} lg={8}>
                    <Input
                        placeholder="Optional, Birth Year Less Than"
                        value={birthYearLessThan}
                        onChange={setBirthYearLessThan}
                    />
                </Col>
            </Row>
            
            <Row spacing="small">
                <Col xs={24} md={8} lg={8}>
                    <Select value={sortOption} placeholder="Sort by" onChange={setSortOption}>
                        <Option value="income">Income</Option>
                        <Option value="fortune">Fortune</Option>
                        <Option value="tax">Tax</Option>
                    </Select>
                </Col>
                <Col xs={24} md={8} lg={8}>
                    <Select value={sortOrder} placeholder="Sort Order" onChange={setSortOrder}>
                        <Option value="Asc">Ascending</Option>
                        <Option value="Desc">Descending</Option>
                    </Select>
                </Col>
            </Row>
            <Row gutter={["tiny", "tiny"]}>
                <Col xs={6} md={12} lg={4}>
                    <Button
                        fill
                        type="submit"
                        busy={busy}
                        icon="search"
                        color="primary"
                        onClick={handleFilter}
                        disabled={!year}
                    >
                        Søk
                    </Button>
                </Col>
                <Col xs={6} md={12} lg={4}>
                    <Button
                        fill
                        type="button"
                        onClick={clearFields}
                    >
                        Clear
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};
